export default "__VITE_ASSET__6cb97a31__"